import { gql } from '@apollo/client/core';

export const MODULE_CLONE_CURRICULUM = gql`
  query ModuleCloneCurriculum($programmeId: Int!) {
    listCurriculumsByProgram(prog_id: $programmeId) {
      id course_registration_level semester
      course { id course_code course_title }
    }
  }
`;
